// extracted by mini-css-extract-plugin
export default {"typeMap":"MapAction_typeMap__6DySe","typeMapClone":"MapAction_typeMapClone__IVO9+"};